<mat-card dir="rtl">

    <mat-card-header>
        <!-- <mat-card-title class="text-center">وضعیت تراکنش</mat-card-title> -->
    </mat-card-header>

    <mat-card-content>
        <div class="text-center">
            <i [ngClass]="{
                'fa-check-circle text-success': queryParams?.status,
                'fa-exclamation-circle text-danger': !queryParams?.status
            }" class="fas fa-6x">
            </i>
        </div>

        <div class="text-center">
            <h3 *ngIf="queryParams?.status == true">تراکنش با موفقیت انجام شد</h3>
            <h3 *ngIf="queryParams?.status == false">تراکنش با خطا مواجه شده است</h3>
        </div>

        <ul class="list-group">
            <li class="list-group-item">
                <div>کد پیگیری</div>
                <div>
                    <b>{{queryParams?.refid}}</b>
                </div>
            </li>
            <li class="list-group-item">
                <div>مبلغ تراکنش</div>
                <div>
                    <b>{{queryParams?.amount | number}} ریال</b>
                </div>
            </li>
            <li class="list-group-item">
                <div>شماره کارت مقصد</div>
                <div dir="ltr">
                    <b>{{queryParams?.cardno | creditCard}}</b>
                </div>
            </li>
        </ul>
    </mat-card-content>

    <mat-card-actions>
        <div class="text-center">
            <button mat-stroked-button color="primary" [routerLink]="['/destination-account']">
                بازگشت به صفحه اصلی
            </button>
        </div>
    </mat-card-actions>

</mat-card>